import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.section`
  padding: 0 15px;
`;

export const UploadButton = styled(Button)`
  height: 56px;
  margin-top: 16px;

  & span {
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.1px;
    text-align: center;
    color: ${({ theme }) => theme.imagePicker.buttonTextColor};
  }

  & input {
    display: none;
  }
`;

export const Label = styled.label`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: -0.1px;
  text-align: left;
  padding: 0;
  margin-top: 29px;
  color: ${({ theme }) => theme.imagePicker.label};
`;

export const Image: any = styled.div`
  position: relative;
  width: 100%;
  height: 150px;
  border-radius: 16px;
  margin: 24px auto;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.imagePicker.background};
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.imagePicker.shadow};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background-image: linear-gradient(
      rgba(${ColorPalette.RGB.Black}, 0.5),
      rgba(${ColorPalette.RGB.Black}, 0.1) 30%,
      transparent 45%
    );
  }
`;

Image.Src = styled.img`
  width: 100%;
`;

Image.Zoom = styled.img`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const Trash = styled.button`
  display: flex;
  text-align: center;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: none;
  width: fit-content;
  margin: 0 auto;
  cursor: pointer;

  & label {
    padding: 0;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.67;
    letter-spacing: 0.2px;
    text-align: center;

    color: ${({ theme }) => theme.imagePicker.trashTextColor};
    cursor: pointer;
  }

  & img {
    margin-left: 5px;
    width: 20px;
    height: 20px;
    object-fit: contain;
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.imagePicker.background};
    border: none;
  }
`;
